import { Link } from "react-router-dom";
import { assetUrl } from "@/lib/api";
import { FileText, Mic, Video, File, LinkIcon, Camera } from "@/lib/icons";

export function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  if (sameDay) return "Today · " + d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  return d.toLocaleDateString([], { month: "short", day: "numeric" }) + " · " + d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export const TYPE_META = {
  note: { icon: FileText, color: "#10B981" },
  photo: { icon: Camera, color: "#3B82F6" },
  audio: { icon: Mic, color: "#A855F7" },
  video: { icon: Video, color: "#EF4444" },
  file: { icon: File, color: "#F59E0B" },
  link: { icon: LinkIcon, color: "#F97316" },
};

export function PageHeader({ eyebrow, title, subtitle, color = "#2563EB", right }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6 dl-rise">
      <div>
        {eyebrow && <div className="font-mono-label text-[11px] mb-1.5" style={{ color }}>{eyebrow}</div>}
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">{title}</h1>
        {subtitle && <p className="text-sm text-slate-400 mt-1">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint, action }) {
  return (
    <div className="dl-card grid place-items-center text-center py-16 px-6" data-testid="empty-state">
      {Icon && <div className="h-14 w-14 rounded-2xl grid place-items-center mb-4" style={{ background: "rgba(37,99,235,0.12)" }}><Icon size={26} className="text-sky-400" /></div>}
      <h3 className="font-display text-lg text-white">{title}</h3>
      {hint && <p className="text-sm text-slate-400 mt-1 max-w-sm">{hint}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

const STATE_STYLES = {
  inbox: { bg: "rgba(245,158,11,0.15)", c: "#F59E0B", label: "To catalog" },
  reviewed: { bg: "rgba(16,185,129,0.15)", c: "#10B981", label: "Reviewed" },
  archived: { bg: "rgba(100,116,139,0.15)", c: "#94A3B8", label: "Archived" },
  uploading: { bg: "rgba(59,130,246,0.15)", c: "#3B82F6", label: "Uploading" },
  failed: { bg: "rgba(239,68,68,0.15)", c: "#EF4444", label: "Failed" },
};
export function StatusBadge({ state }) {
  const s = STATE_STYLES[state] || STATE_STYLES.archived;
  return <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full" style={{ background: s.bg, color: s.c }}>{s.label}</span>;
}

export function CaptureThumb({ cap, size = "md" }) {
  const meta = TYPE_META[cap.type] || TYPE_META.note;
  const Icon = meta.icon;
  const h = size === "lg" ? "h-40" : "h-28";
  return (
    <Link to={`/captures/${cap.id}`} data-testid={`capture-card-${cap.id}`} className="dl-card overflow-hidden block group">
      <div className={`${h} relative overflow-hidden`} style={{ background: "rgba(255,255,255,0.03)" }}>
        {cap.thumb_asset_id ? (
          <img src={assetUrl(cap.thumb_asset_id)} alt={cap.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        ) : (
          <div className="w-full h-full grid place-items-center">
            <Icon size={28} style={{ color: meta.color }} />
          </div>
        )}
        <span className="absolute top-2 left-2 h-6 w-6 rounded-md grid place-items-center backdrop-blur" style={{ background: "rgba(7,11,20,0.6)" }}>
          <Icon size={13} style={{ color: meta.color }} />
        </span>
      </div>
      <div className="p-3">
        <div className="text-sm font-semibold text-white truncate">{cap.title || "Untitled"}</div>
        <div className="text-[11px] text-slate-500 mt-0.5">{fmtDate(cap.created_at)}</div>
      </div>
    </Link>
  );
}
